import { useEffect, useState } from "react";

interface Props {
  startedAt: number;
  durationSec: number;
  onExpire?: () => void;
}

export function TimerBar({ startedAt, durationSec, onExpire }: Props) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const i = setInterval(() => setNow(Date.now()), 100);
    return () => clearInterval(i);
  }, []);
  const elapsed = (now - startedAt) / 1000;
  const remaining = Math.max(0, durationSec - elapsed);
  const pct = Math.max(0, Math.min(1, remaining / durationSec));

  useEffect(() => {
    if (remaining <= 0) onExpire?.();
  }, [remaining, onExpire]);

  const hue = pct > 0.5 ? 150 : pct > 0.2 ? 40 : 0;
  const color = `hsl(${hue}, 80%, 56%)`;

  return (
    <div className="flex items-center gap-3">
      <div className="flex-1 h-2 rounded-full overflow-hidden bg-white/5">
        <div
          className="h-full transition-[width] duration-100 ease-linear"
          style={{ width: `${pct * 100}%`, background: color }}
        />
      </div>
      <span className="font-mono text-sm tabular-nums" style={{ color }}>
        {remaining.toFixed(1)}s
      </span>
    </div>
  );
}
